module.exports = __webpack_public_path__ + "static/media/green-bus.94d0a909.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/img/green-bus.png
// module id = 914
// module chunks = 0